import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Identity } from '../../portfolio.data';

@Component({
  selector: 'app-hero',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss']
})
export class HeroComponent {
  @Input({ required: true }) identity!: Identity;
  @Input({ required: true }) headline!: string;

  get age(): number {
    return new Date().getFullYear() - this.identity.birthYear;
  }
}
